import React, {useEffect, useState} from 'react';
import api from '../services/api';
import '../styles/KPI.css';


export default function KPI() {

    const [activeTab, setActiveTab] = useState('password');

    return (
        <div className="kpi-container">
            <h2>KPI</h2>

            <div className="internal-nav">
                <button
                    className={`internal-tab ${activeTab === 'bwa' ? 'active' : ''}`}
                    onClick={() => setActiveTab('bwa')}>
                    BWA
                </button>
                <button
                    className={`internal-tab ${activeTab === 'employee' ? 'active' : ''}`}
                    onClick={() => setActiveTab('employee')}>
                    Mitarbeiter
                </button>
            </div>

            {activeTab === 'bwa' && (
                <div className="bwa">
                    <h3>BWA</h3>

                </div>
            )}

            {activeTab === 'employee' && (
                <div className="employee">
                    <h3>Employee</h3>

                </div>
            )}




        </div>
    );
}
